import React from 'react';
import { connect } from 'react-redux';
// GameGuide imports
import { setPublishState, prevStep } from '../../../actions/gameGuideActions';
import { GuidePublishState } from '../../../shared';
import ThumbnailPicker from './ThumbnailPicker';
// Popup imports
import { OpenPopup } from '../../../actions/popupActions';
import { PopupTypes, PopupStates } from '../../Popup/Enums';
// Game(kit) imports
import gameKit from '../../../../GameKit';
// Shared imports
import settings from '../../../../settings';

class ButtonsContainer extends React.Component {
    onPublishSuccess = () => {
        const { dispatch } = this.props;
        dispatch(setPublishState(GuidePublishState.SUCCESS));
    };

    onPublishError = resp => {
        const { dispatch } = this.props;
        dispatch(OpenPopup(PopupTypes.PUBLISH, PopupStates.ERROR, { response: resp }));
    };

    onBack = () => {
        const { dispatch } = this.props;
        dispatch(prevStep());
    };

    onPublish = () => {
        // Check if all attributes are valid
        const { dispatch, game } = this.props;
        let errors = GuidePublishState.NONE;
        if (game.levels.length <= 0) {
            errors |= GuidePublishState.LEVELS;
        }
        if (game.title.trim().length <= 0) {
            errors |= GuidePublishState.TITLE;
        }
        if (game.description.trim().length <= 0) {
            errors |= GuidePublishState.DESC;
        }
        if (game.thumbnail === undefined) {
            errors |= GuidePublishState.THUMBNAIL;
        }

        if (errors !== GuidePublishState.NONE) {
            dispatch(setPublishState(errors));
            return;
        }
        // Publish game if every thing is correct
        gameKit.publishGame(this.onPublishSuccess, this.onPublishError);
    };

    render = () => {
        const { gameGuide } = this.props;

        const imgPath = gameGuide.publishState === GuidePublishState.NONE ? `${settings.assetsPath}img/publiceer_monstertje.png` : `${settings.assetsPath}img/publiceer_monstertje_error.png`;

        return (
            <div className="buttons-container">
                <ThumbnailPicker
                    backBtn={
                        <button type="button" onClick={this.onBack}>
                            terug
                        </button>
                    }
                />
                <div className="btn-publish-container">
                    <img src={imgPath} alt="Cactus wilt spelen" />
                    <button type="button" onClick={this.onPublish}>
                        publiceer!
                    </button>
                </div>
            </div>
        );
    };
}

const mapDispatchToProps = dispatch => ({
    dispatch
});

const mapStateToProps = state => ({
    game: state.game,
    gameGuide: state.gameGuide
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ButtonsContainer);
